import { render } from "./ViewerContainer.vue?vue&type=template&id=23344852&scoped=true&ts=true"
import script from "./ViewerContainer.vue?vue&type=script&lang=ts"
export * from "./ViewerContainer.vue?vue&type=script&lang=ts"

import "./ViewerContainer.vue?vue&type=style&index=0&id=23344852&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23344852"]])

export default __exports__